import React, { useState } from 'react';
import Dialog from './Dialog';

interface TableDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onInsert: (rows: number, cols: number) => void;
}

const TableDialog: React.FC<TableDialogProps> = ({ isOpen, onClose, onInsert }) => {
  const [rows, setRows] = useState(3);
  const [cols, setCols] = useState(3);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onInsert(rows, cols);
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Insert Table">
      <form onSubmit={handleSubmit} className="mj-table-dialog-form">
        <div className="mj-form-group">
          <label htmlFor="table-rows">Number of Rows:</label>
          <input
            id="table-rows"
            type="number"
            min="1"
            max="20"
            value={rows}
            onChange={(e) => setRows(parseInt(e.target.value) || 1)}
            className="mj-form-input"
          />
        </div>
        
        <div className="mj-form-group">
          <label htmlFor="table-cols">Number of Columns:</label>
          <input
            id="table-cols"
            type="number"
            min="1"
            max="10"
            value={cols}
            onChange={(e) => setCols(parseInt(e.target.value) || 1)}
            className="mj-form-input"
          />
        </div>

        <div className="mj-dialog-preview">
          <h4>Preview:</h4>
          <div className="mj-table-preview">
            {Array.from({ length: Math.min(rows, 5) }, (_, i) => (
              <div key={i} className="mj-table-row">
                {Array.from({ length: Math.min(cols, 5) }, (_, j) => (
                  <div key={j} className="mj-table-cell">
                    {i === 0 ? `Header ${j + 1}` : `Cell ${i + 1}-${j + 1}`}
                  </div>
                ))}
              </div>
            ))}
            {rows > 5 && <div className="mj-table-more">... and {rows - 5} more rows</div>}
            {cols > 5 && <div className="mj-table-more">... and {cols - 5} more columns</div>}
          </div>
        </div>

        <div className="mj-dialog-actions">
          <button type="button" onClick={onClose} className="mj-btn mj-btn-secondary">
            Cancel
          </button>
          <button type="submit" className="mj-btn mj-btn-primary">
            Insert Table
          </button>
        </div>
      </form>
    </Dialog>
  );
};

export default TableDialog; 